export default __webpack_public_path__ + "static/media/tsp.49afb1b6.png";